import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <div data-layout="admin" class="min-h-screen">
      <router-outlet />
    </div>
  `
})
export class AdminLayoutComponent {}
